import dayjs from "dayjs";

export const getBuildDate = (epoch) => {
    const buildDate = dayjs(epoch).format("DD-MM-YYYY HH:MM");
    return buildDate;
};